// extracted by mini-css-extract-plugin
export default {"fields":"YIFf30","time":"z7qhCF","mobile":"U5G4bB"};